interface ExternalLinkIconProps {
  color?: string;
}

export const ExternalLinkIcon = ({ color = '#E6E6E9' }: ExternalLinkIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 15 15"
    fill="none"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M3.96442 11.0355L11.0355 3.96442M11.0355 3.96442V9.26775M11.0355 3.96442H5.73218"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
